import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49962d0e")

_pushScopeId("data-v-49962d0e")
const _hoisted_1 = { class: "nav-menu" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MenuDesktopList = _resolveComponent("MenuDesktopList")
  const _component_SearchBlock = _resolveComponent("SearchBlock")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MenuDesktopList, { class: "nav-menu__menu" }),
    _createVNode(_component_SearchBlock, { class: "nav-menu__search-block" })
  ]))
})